
      import '@folkjs/labs/standalone/ast-gizmos';

      const editor = document.getElementById('editor');
      const output = document.getElementById('output');

      // Set initial content with various literal types
      editor.value = `// Example with different types of pattern-matched AST gizmos
const message = "Hello, World!";
const count = 42;
const enabled = true;
const coordinates = [10, 20, 30];
const createdAt = "2024-03-20T15:30:00.000Z";  // ISO datetime string

// Simple dimension object
const dims = { width: 100, height: 100 };

// Square path
const points = [
    { x: 0, y: 0 },    // Origin
    { x: 100, y: 0 },  // Right
    { x: 100, y: 100 },// Corner
    { x: 0, y: 100 },  // Up
];

// Triangle path
const triangle = [
    { x: 50, y: 0 },
    { x: 100, y: 100 },
    { x: 0, y: 100 },
];

const config = {
    name: "test",
    values: [1, 2, 3],
    settings: {
        debug: true,
        mode: "development"
    }
};

// Matrix2D object
const matrix = {
      a: 1,
      b: 0,
      c: 0,
      d: 1,
      e: 0,
      f: 0,
    };
`;

      // Listen for changes
      editor.addEventListener('change', (e) => {
        output.textContent = e.detail.value;
      });

      // Initial output
      output.textContent = editor.value;
    